// @flow @format

import { combineEpics, ofType } from 'redux-observable';
import { map, mapTo, switchMap } from 'rxjs/operators';

import type { ActionType } from '../utils';
import type { ObservableAction, StateObservable } from './types';
import { catchWith } from './utils';
import { fetchJsonFromS3, uploadJsonToS3 } from './s3Helper';
import {
  fetchUserConfigBegin,
  fetchUserConfigFailure,
  fetchUserConfigSuccess,
  setConfigMute,
  uploadUserConfigBegin,
  uploadUserConfigFailure,
  uploadUserConfigSuccess,
} from '../reducer/config';

export function fetchUserConfigEpic(action$: ObservableAction, state$: StateObservable): ObservableAction {
  return action$.pipe(
    ofType<ActionType<typeof fetchUserConfigBegin>>(fetchUserConfigBegin.type),
    switchMap(() =>
      fetchJsonFromS3(state$.value, 'config.json').pipe(
        map(fetchUserConfigSuccess),
        catchWith(fetchUserConfigFailure, undefined)
      )
    )
  );
}

export function uploadUserConfigEpic(action$: ObservableAction, state$: StateObservable): ObservableAction {
  return action$.pipe(
    ofType<ActionType<typeof uploadUserConfigBegin>>(uploadUserConfigBegin.type),
    switchMap(() =>
      uploadJsonToS3(state$.value, 'config.json', state$.value.config).pipe(
        map(uploadUserConfigSuccess),
        catchWith(uploadUserConfigFailure, undefined)
      )
    )
  );
}

export function configChangedEpic(action$: ObservableAction): ObservableAction {
  return action$.pipe(ofType<ActionType<typeof setConfigMute>>(setConfigMute.type), mapTo(uploadUserConfigBegin()));
}

export default combineEpics(fetchUserConfigEpic, uploadUserConfigEpic, configChangedEpic);
